import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Tabs, InputNumber } from 'antd';
import { HomeOutlined, CloseCircleOutlined, RedoOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';
import SelectStudent from './selectStudent';
import SelectCohortModule from './selectCohortModule';
import moment from 'moment';//日期格式化导包
import CohortProgSearchModal from './cohortProgSearchModal'
import './studentModuleRecord.css';
const { TabPane } = Tabs;
const { Option } = Select;

const StudentModuleRecord = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramSegmentList, setParamSegmentList] = useState([]);
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [selected, setSelected] = useState([]);
    const [updateInfoModel, setUpdateInfoModel] = useState({});

    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [isSelectStudent, setIsSelectStudent] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [selectedSRowKeys, setSelectedRowKeys] = useState([]);
    const [cohortList, setCohortList] = useState([]);
    const [assignedList, setAssignedList] = useState([]);
    const [assignmentTable, setAssignmentTable] = useState([]);
    const [wpaTable, setWpaTable] = useState([]);
    const [existMc, setExistMc] = useState(false);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    
    const tableColumns = {
        segmentName: "short_desc",
        code: "code",
        dispSeq: "disp_seq"
    }


    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("studentModuleRecord/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setSelectedRowKeys([])
        setSelected([])
        setCohortProgModel({});
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ status: "ACTIVE" });
        setFlag("add");
        setTabIndex("2");
        setAssignmentTable([])
        setWpaTable([])
        setAssignedList([])
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? '',
            cohortYear: model.cohortYear ?? '',
            semester: model.semester ?? '',
            studentAcctId: model.studentAcctId ?? '',
            firstName: model.firstName ?? '',
            moduleCode: model.moduleCode ?? '',
            moduleName: model.moduleName ?? '',
            progCode: model.progCode ?? '',
            progTitle: model.progTitle ?? '',
            academicSupervisorUserId: model.academicSupervisorUserId ?? '',
            staffName: model.staffName ?? '',
            status: model.status ?? '',
            group: model.group ?? '',
            assignMarks: model.assignMarks ?? 'N/A',
            wpaMarks: model.wpaMarks ?? 'N/A',
            totalModuleMark: model.totalModuleMark ?? 'N/A',
        });
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {

    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }


    const onSave = (values) => {
        messageShowHandler();
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "N");
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        initForm(model);
        setFlag("edit");
        searchById(model.studentModuleId)
        setTabIndex("2");
    }

    const searchById = (studentModuleId, isDelete) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("studentModuleRecord/searchById", { studentModuleId: studentModuleId }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setParamModel(model)
                setStudentModel(model)
                setFlag("edit");
                initForm(model)
                setAssignmentTable(model.studentModuleAssignModelList)
                setWpaTable(model.wpaApplModelList)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadClose = (flag, model) => {
        if (flag) {
            setStudentModel({
                ...studentModel, ...{
                    firstName: model.firstName,
                    studentAcctId: model.studentAcctId,
                    studentId: model.studentId
                }
            })
            form.setFieldsValue({
                firstName: model.firstName ?? "",
                studentAcctId: model.studentAcctId ?? '',
            });
        }
        setIsSelectStudent(false);
    }

    const selectCohortModuleClose = (flag, model) => {
        if (flag) {
            if (tabIndex === "1") {
                setSearchModel(model1 => {
                    return { ...model1, ...{ moduleCode: model.moduleCode } };
                });
            } else {
                setStudentModel({
                    ...studentModel, ...{
                        moduleCode: model.moduleCode,
                        moduleName: model.moduleName,
                        cohortModuleId: model.cohortModuleId,
                        progCode: model.progCode ?? "",
                        progTitle: model.progTitle ?? '',
                        cohortId: model.progTitle ?? '',
                    }

                })
                form.setFieldsValue({
                    moduleCode: model.moduleCode ?? "",
                    moduleName: model.moduleName ?? '',
                    progCode: model.progCode ?? "",
                    progTitle: model.progTitle ?? '',
                    cohortId: model.cohortId ?? '',
                    academicSupervisorUserId: ""
                });
            }
        }

        setIsSearchModuleModal(false);
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelected(selectedRows);
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, cohortProgId: cohortProg.cohortProgId} };
            });
            setCohortProgModel(cohortProg);
        }
        setIsSearchCohortProgModal(false);

    }

    const columns = [
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth3',
        },
        {
            title: "Semester",
            dataIndex: 'semester',
            className: 'tableWidth4',
        },
        {
            title: "Student ID",
            dataIndex: 'studentAcctId',
            className: 'tableWidth5',
        },
        {
            title: "Student Name",
            dataIndex: 'firstName',
            className: 'tableWidth5',
            render: (text, record) => (record?.firstName ?? '') + ' ' + (record?.lastName ?? '')
        },
        {
            title: "Module Code",
            dataIndex: 'moduleCode',
            className: 'tableWidth5',
        },
        {
            title: "Module Name",
            dataIndex: 'moduleName',
            className: 'tableWidth5',
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth5',
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth5',
        },
        {
            title: "Assigned-AS",
            dataIndex: 'staffName',
            className: 'tableWidth5',
        },
        {
            title: "Assignment 1",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 1);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 2",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 2);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 3",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 3);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 4",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 4);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 5",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 5);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 6",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 6);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 7",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 7);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 8",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 8);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 9",
            dataIndex: 'assignMarks',
            className: 'tableWidth4',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 9);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 10",
            dataIndex: 'assignMarks',
            className: 'tableWidth5',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 10);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "WPA Mark",
            dataIndex: 'wpaMarks',
            className: 'tableWidth4',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: "Total Module Mark",
            dataIndex: 'totalModuleMark',
            className: 'tableWidth6',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: 'Grade',
            dataIndex: 'totalModuleMark',
            className: 'tableWidth3',
            render: (text) => (text || text == 0) && Base.calcGrade(text)
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth4',
            render: (text) => ContextHandler.getMapValue('studentModuleStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            width: 90,
            className: 'sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canView === "N"}><EyeOutlined /> {trans.detail[Config.backLang]}</div>
                {/* <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div> */}
            </div>
        },
    ];

    const assignmentColumns = [
        {
            title: 'Assignment',
            dataIndex: 'assignSeq',
            className: 'tableWidth8',
        },
        {
            title: 'Assignment Name',
            dataIndex: 'assignName',
            className: 'tableWidth30',
        },
        {
            title: 'Weighting',
            dataIndex: 'assignWeight',
            className: 'tableWidth10',
        },
        {
            title: 'Assignment Deadline',
            dataIndex: 'assignDeadline',
            className: 'tableWidth12',
            render: (text) => <div>
                <div>{text ? moment(text).format(Config.dateFormat5) : ""}</div>
            </div>
        },
        {
            title: 'Use Turnitin',
            dataIndex: 'turnitinReqInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: 'Turnitin Score',
            dataIndex: 'turnitinScore',
            className: 'tableWidth10',
            render: (text) => text === 0? '0%' : text? `${text}%` : ''
        },
        {
            title: 'Assign Mark',
            dataIndex: 'assignMarks',
            className: 'tableWidth10',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('assignmentStatusMap', text)
        },


    ];


    const wpaColumns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            className: 'tableWidth6',
        },
        {
            title: 'Company',
            dataIndex: 'companyName',
            className: 'tableWidth34',
        },
        {
            title: 'Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            className: 'tableWidth30',
        },
        {
            title: 'WIL Hours',
            dataIndex: 'wilHours',
            className: 'tableWidth6',
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            className: 'tableWidth5',
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Submit Date ',
            dataIndex: 'applyDate',
            className: 'tableWidth7',
            render: (text) => <div>
                <div>{text ? moment(text).format(Config.dateFormat5) : ""}</div>
            </div>
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('wpaFormStatusMap', text)
        },

    ];

    const rowSelection = {
        selectedRowKeys: selectedSRowKeys,
        onChange: onSelectChange,
    };

    return (
        <div id="container" className="template studentModuleRecord">
            <div className='breadcrumb'>
                <HomeOutlined /> / Setup / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.firstName || ''}
                                            placeholder="Student Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('firstName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.studentAcctId || ''}
                                            placeholder="Student ID"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Module</div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.moduleCode || ''} disabled
                                            placeholder="Module"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                                    {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme </div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.progCode || ''} disabled
                                            placeholder="Programme "
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                                    {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Assigned-AS</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.staffName || ''}
                                            placeholder="Assigned-AS"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('staffName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="studentModuleId"
                                    scroll={{ x: 3100 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab="Enrolled Module Student Record Data" key="2" forceRender={true}>
                            <Form form={form} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Student ID</div>
                                        <div className={flag === "add" ? "sysInput btnInput" : "sysInput"}>
                                            <Form.Item
                                                name="studentAcctId"
                                                rules={[
                                                    { required: true, message: "Student ID is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Student ID' disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        {
                                            flag === "add" &&
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => setIsSelectStudent(true)}>Select</Button>
                                        }

                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Student Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="firstName"
                                            >
                                                <Input type="text" placeholder='Student Name' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Module Code</div>
                                        <div className={flag === "add" ? "sysInput btnInput" : "sysInput"}>
                                            <Form.Item
                                                name="moduleCode"
                                                rules={[
                                                    { required: true, message: "Module Code is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Module Code' disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        {
                                            flag === "add" &&
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => setIsSearchModuleModal(true)}>Select</Button>
                                        }
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Module Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleName"
                                            >
                                                <Input type="text" placeholder='Module Name' maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">Programme Code</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progCode"
                                            >
                                                <Input type="text" placeholder='Programme Code' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Programme Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                            >
                                                <Input type="text" placeholder='Programme Name' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortYear"
                                                rules={[
                                                    { required: true, message: "Cohort is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Cohort' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Semester</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="semester"
                                            >
                                                <InputNumber type="text" placeholder='Semester' maxLength={1} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Assigned-AS</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="staffName"
                                                rules={[
                                                    { required: true, message: "Assigned-AS is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Assigned-AS' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Sub Group</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="group"
                                            >
                                                <Select className="sysSelect" placeholder="Sub Group" disabled >
                                                    <Option value=''></Option>
                                                    {context.num9Map.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {
                                    flag === "edit" &&
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam">Assign Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignMarks"
                                                >
                                                    <Input type="text" placeholder='Assign Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam">WPA Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaMarks"
                                                >
                                                    <Input type="text" placeholder='WPA Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Status</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                                rules={[
                                                    { required: true, message: "Status is required." },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder="Status" disabled>
                                                    <Option value=''></Option>
                                                    {context.studentModuleStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {flag === "edit" &&
                                        <div className='sysCol'>
                                            <div className="sysParam">Total Module Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="totalModuleMark"
                                                >
                                                    <Input type="text" placeholder='Total Module Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="sysSaveButton">
                                    {/* <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button> */}
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                            <div className="">
                                <div className="userRoleTitleRow2">Assignment</div>
                            </div>
                            <div className="packing-table " id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="studentModuleAssignId" //Key值
                                    columns={assignmentColumns} //列名
                                    dataSource={assignmentTable} //数据
                                    pagination={false}
                                />
                            </div>

                            <div className="">
                                <div className="userRoleTitleRow2">WPA</div>
                            </div>
                            <div className="packing-table " id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="wpaApplId" //Key值
                                    columns={wpaColumns} //列名
                                    dataSource={wpaTable} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isSearchModuleModal && <SelectCohortModule onClose={selectCohortModuleClose} />}
            {isSelectStudent && <SelectStudent onClose={uploadClose} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} />}
        </div>
    )

}

export default StudentModuleRecord;